// extracted by mini-css-extract-plugin
export var avatar = "_rw-3";
export var avatarContainer = "_rw-2";
export var avatarSpacer = "_rw-5";
export var avatarSpacerContainer = "_rw-4";
export var avatarStackContainer = "_rw-1";
export var bubble = "_rw-0";
export var remainderBubble = "_rw-6";